import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIconSpriteContext } from '#pplx/frontend/icons/IconSpriteContext.js';
import { cx } from 'class-variance-authority';
import { memo } from 'react';
const DEFAULT_STROKE_WIDTH_PX = 1.75;
/**
 * IconSprite — internal sprite-sheet icon renderer for IconPrimitive.
 *
 * This is an Aether-internal implementation detail of the icon system.
 * Use `IconPrimitive` with `type="sprite"` (the default) instead of
 * importing this directly.
 */
export const IconSprite = memo(function Icon({ name, size = 'default', strokeWidth = DEFAULT_STROKE_WIDTH_PX, title, description, className, style, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, }) {
    const ctx = useIconSpriteContext();
    const iconSize = size === 'default' ? ctx.defaultSize : size === 'inherit' ? '1em' : size;
    return (_jsxs("svg", { role: "img", className: cx('inline-flex fill-current shrink-0', className), width: iconSize, height: iconSize, strokeWidth: strokeWidth, style: style, "aria-label": ariaLabel, "aria-hidden": ariaHidden, children: [title && _jsx("title", { children: title }), description && _jsx("desc", { children: description }), _jsx("use", { xlinkHref: ctx.src({ id: name, version: ctx.version }) })] }));
});
//# sourceMappingURL=IconSprite.js.map